module.exports = __webpack_public_path__ + "aaee34a67488aa41b90919c225da96f0.svg";